// extracted by mini-css-extract-plugin
export default {"wrap":"AccessDenied_wrap__bA7h0","icon":"AccessDenied_icon__saRxc","title":"AccessDenied_title__7Bg0i","sub":"AccessDenied_sub__u3j7G","role":"AccessDenied_role__e0neB"};